export enum MaritalStatus {
  EI_TIETOA = 'EI_TIETOA',
  NAIMATON = 'NAIMATON',
  AVIOLIITOSSA = 'AVIOLIITOSSA',
  ASUMUSEROSSA = 'ASUMUSEROSSA',
  ERONNUT = 'ERONNUT',
  LESKI = 'LESKI',
  REKISTEROIDYSSA_PARISUHTEESSA = 'REKISTEROIDYSSA_PARISUHTEESSA',
  ERONNUT_REKISTEROIDYSTA_PARISUHTEESTA = 'ERONNUT_REKISTEROIDYSTA_PARISUHTEESTA',
  LESKI_REKISTEROIDYN_PARISUHTEEN_JALKEEN = 'LESKI_REKISTEROIDYN_PARISUHTEEN_JALKEEN',
}
